"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validateFileSize = exports.confirmCompress = void 0;
var _messageBox = _interopRequireDefault(require("element-ui/packages/message-box"));
var _index = require("./index");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const confirmCompress = async (size, maxFileSize, allowCompress) => {
  try {
    return _messageBox.default.confirm(`<div>
           <div>B\u1EA1n \u0111ang upload \u1EA3nh c\xF3 k\xEDch th\u01B0\u1EDBc ${(0, _index.bytesToSize)(size)}</div>
           <div>B\u1EA1n c\u1EA7n upload \u1EA3nh c\xF3 k\xEDch th\u01B0\u1EDBc ${(0, _index.bytesToSize)(maxFileSize)}</div>
      </div>`, "C\u1EA3nh b\xE1o", {
      showConfirmButton: allowCompress,
      confirmButtonText: "N\xE9n \u1EA3nh n\xE0y",
      cancelButtonText: "Upload \u1EA3nh kh\xE1c",
      type: "warning",
      dangerouslyUseHTMLString: true
    });
  } catch {
    return false;
  }
};
exports.confirmCompress = confirmCompress;
const validateFileSize = async (file, {
  allowCompress,
  allowFileSize,
  maxFileSize,
  callbackCompress
}) => {
  if (!allowFileSize) return true;
  if (file.size <= maxFileSize) return true;
  const isConfirm = await confirmCompress(file.size, maxFileSize, allowCompress);
  if (!isConfirm || !callbackCompress) {
    throw "INVALID_FILE_SIZE";
  } else {
    await callbackCompress();
  }
};
exports.validateFileSize = validateFileSize;